<template>
  <div class="apo">
    <img class="ss" src="/favicon.ico" alt="" />
    <div class="aa">
      <div style="margin-top: 20px; font-size: 18px; font-weight: 1000">
        <span
          style="
            padding-bottom: 10px;
            width: 100px;
            border-bottom: 2px solid #00b2ff;
          "
        >
          登 录 查 询
        </span>
      </div>
      <div style="margin-top: 50px">
        <van-form @submit="onSubmit">
          <van-field
            v-model="value"
            name="用户名"
            style="
              border-radius: 5px;
              width: 90%;
              margin-left: 5%;
              padding: 10px;
              background-color: #eeeeee;
            "
            autocomplete="on"
            placeholder="请输入您的设备号"
          >
            <template #button>
              <img
                style="
                  width: 25px;
                  height: 25px;
                  margin-top: 4px;
                  text-align: center;
                "
                src="../assets/扫码png.png"
                alt=""
              />
            </template>
          </van-field>

          <div style="margin: 16px">
            <van-button
              block
              type="info"
              native-type="submit"
              :loading="loading"
              style="width: 100%; margin-top: 30px; border-radius: 10px"
            >
              查询
            </van-button>
          </div>
        </van-form>
      </div>
      <van-popup v-model="shows" position="bottom">
        <van-picker
          show-toolbar
          :columns="cardList"
          @confirm="onConfirm"
          @cancel="shows = false"
        />
      </van-popup>
      <van-dialog
        v-model="nameAlerts"
        confirmButtonText="立即绑定"
        confirmButtonColor="red"
        @confirm="changse"
        :showCancelButton="true"
        :close-on-click-overlay="false"
        title="绑定手机"
      >
        <div style="margin-top: 10px" v-if="sspa.type == 1">
          <van-field
            style="border-radius: 40px"
            v-model="form.phone"
            type="tel"
            label="手机号"
            placeholder="请输入手机号"
          />

          <van-field
            v-model="form.random"
            center
            style="border-radius: 40px"
            clearable
            label="验证码"
            placeholder="请输入短信验证码"
          >
            <template #button>
              <van-button
                size="small"
                v-if="dd == false"
                @click="change"
                round
                type="info"
              >
                验证码
              </van-button>
              <van-button size="small" v-if="dd" disabled round>
                <van-count-down
                  ref="count0"
                  :time="time"
                  :auto-start="false"
                  format="ss"
                  @finish="finishss"
                />
              </van-button>
            </template>
          </van-field>
        </div>
        <div style="margin-top: 10px" v-if="sspa.type == 2">
          <van-field
            style="border-radius: 40px"
            v-model="form.name"
            label="姓名"
            placeholder="请输入姓名"
          />

          <van-field
            v-model="form.phone"
            center
            style="border-radius: 40px"
            clearable
            type="tel"
            label="手机号"
            placeholder="请输入手机号"
          ></van-field>

          <van-field
            v-model="form.random"
            center
            style="border-radius: 40px"
            clearable
            label="验证码"
            placeholder="请输入短信验证码"
          >
            <template #button>
              <van-button
                size="small"
                v-if="dd == false"
                @click="change"
                round
                type="info"
              >
                验证码
              </van-button>
              <van-button size="small" v-if="dd" disabled round>
                <van-count-down
                  ref="count0"
                  :time="time"
                  :auto-start="false"
                  format="ss"
                  @finish="finishss"
                />
              </van-button>
            </template>
          </van-field>
        </div>
        <div style="margin-top: 10px" v-if="sspa.type == 3">
          <van-field
            style="border-radius: 40px"
            v-model="form.name"
            label="姓名"
            placeholder="请输入姓名"
          />

          <van-field
            v-model="form.phone"
            center
            style="border-radius: 40px"
            clearable
            type="tel"
            label="手机号"
            placeholder="请输入手机号"
          ></van-field>

          <van-field
            v-model="form.identityCard"
            center
            style="border-radius: 40px"
            clearable
            label="身份证号"
            placeholder="请输入身份证号"
          ></van-field>

          <van-field
            v-model="form.random"
            center
            style="border-radius: 40px"
            clearable
            label="验证码"
            placeholder="请输入短信验证码"
          >
            <template #button>
              <van-button
                size="small"
                v-if="dd == false"
                @click="change"
                round
                type="info"
              >
                验证码
              </van-button>
              <van-button size="small" v-if="dd" disabled round>
                <van-count-down
                  ref="count0"
                  :time="time"
                  :auto-start="false"
                  format="ss"
                  @finish="finishss"
                />
              </van-button>
            </template>
          </van-field>
        </div>
        <div style="margin-top: 10px" v-if="sspa.type == 4">
          <van-field
            style="border-radius: 40px"
            v-model="form.name"
            label="姓名"
            placeholder="请输入姓名"
          />

          <van-field
            v-model="form.phone"
            center
            style="border-radius: 40px"
            clearable
            type="tel"
            label="手机号"
            placeholder="请输入手机号"
          ></van-field>

          <van-field
            v-model="form.identityCard"
            center
            style="border-radius: 40px"
            clearable
            label="身份证号"
            placeholder="请输入身份证号"
          ></van-field>

          <van-field
            v-model="form.random"
            center
            style="border-radius: 40px"
            clearable
            label="验证码"
            placeholder="请输入短信验证码"
          >
            <template #button>
              <van-button
                size="small"
                v-if="dd == false"
                @click="change"
                round
                type="info"
              >
                验证码
              </van-button>
              <van-button size="small" v-if="dd" disabled round>
                <van-count-down
                  ref="count0"
                  :time="time"
                  :auto-start="false"
                  format="ss"
                  @finish="finishss"
                />
              </van-button>
            </template>
          </van-field>
        </div>
      </van-dialog>
      <div style="margin-top: 20px">
        <van-notice-bar
          v-if="notice"
          @click="notices"
          left-icon="volume-o"
          background="#ffffff"
          color="#1989fa"
          :text="notice"
        />
      </div>
    </div>
    <div class="floatball" v-if="keUrl.length > 0" @click="keFn">客服</div>
  </div>
</template>

<script>
  import { getAll, applyWebList } from "@/api/seting";
  import { sortCard, getByCard, phoneQuery } from "@/api/login";
  import { VerificationCode, updateRealType } from "@/api/cardOperation";

  export default {
    data() {
      return {
        loading: false,
        value: "",
        values: "",
        sspa: {},
        notice: "",
        loign: "",
        shows: false,
        cardList: [],
        mk: "",
        nameAlerts: false,
        form: {
          random: "",
          phone: "",
          meCardNum: "",
          identityCard: "",
          name: "",
        },
        iccid: this.$route.params.iccId,
        dd: false,
        a: "",
        s: 0,
        time: 60 * 1000,
        keUrl: "",
      };
    },
    created() {
      if (localStorage.getItem("virtualNumber")) {
        this.value = localStorage.getItem("virtualNumber");
      } else if (this.$route.query.card) {
        this.value = this.$route.query.card;
      } else {
        this.value = localStorage.getItem("card");
      }
    },
    async mounted() {
      await this.ss();
      await this.applyWebList();
    },
    methods: {
      keFn() {
        window.location.href = this.keUrl;
      },
      changse() {
        this.form.meCardNum = this.values;
        updateRealType(this.form).then((res) => {
          if (res.status) {
            if (this.mk == 3) {
              this.$router.push({
                path: "/recharges",
                query: {
                  card: this.values,
                },
              });
            } else {
              this.$router.push({
                path: "/home",
                query: {
                  card: this.values,
                },
              });
            }
            this.$notify({
              type: "success",
              message: res.msg,
            });
          } else {
            this.$notify({
              type: "warning",
              message: res.msg,
            });
          }
        });
      },
      finishss() {
        this.dd = false;
      },
      start() {
        this.$nextTick(() => {
          this.$refs.count0.start();
        });
      },

      change() {
        if (this.form.phone == "") {
          this.$notify({
            type: "warning",
            message: `手机号不能为空`,
          });
        } else {
          VerificationCode(this.form.phone).then((res) => {
            if (res.status) {
              console.log(res);
              this.$notify({
                type: "success",
                message: res.msg,
              });
              this.dd = true;
              this.start();
            } else {
              this.$notify({
                type: "warning",
                message: res.msg,
              });
            }
          });
        }
      },
      ss() {
        getAll().then((res) => {
          if (res.status) {
            localStorage.setItem("title", res.data.weChatWebName);
            document.title = res.data.weChatWebName;
            this.notice = res.data.notice;
            this.loign = res.data.phoneLogin;
            if (res.data.indexCustomerLink) {
              this.keUrl = res.data.indexCustomerLink;
            }
          }
        });
      },
      applyWebList() {
        applyWebList().then((res) => {
          if (res.status) {
            res.data.forEach((element) => {
              if (element.defaults) {
                this.mk = element.id;
              }
            });
          }
        });
      },
      notices() {
        this.$dialog
          .alert({
            message: this.notice,
          })
          .then(() => {
            // on close
          });
      },
      onConfirm(value) {
        this.values = value;
        sortCard(value).then((res) => {
          if (res.status) {
            this.sspa = res.data;
            if (res.data.virtualNumber) {
              localStorage.setItem("virtualNumber", res.data.virtualNumber);
            }
            localStorage.setItem("card", value);
            localStorage.removeItem("end");
            getByCard(this.values).then((res) => {
              if (res.status) {
                if (this.sspa.coupon == 1) {
                  this.$router.push({
                    name: "Discount",
                  });
                } else {
                  if (this.sspa.codes == 1) {
                    console.log(this.sspa.codes);
                    this.nameAlerts = true;
                    localStorage.setItem("meCardNum", this.values);
                    localStorage.setItem("card", this.values);
                  } else {
                    localStorage.removeItem("222");
                    if (this.mk == 3) {
                      this.$router.push({
                        path: "/recharges",
                        query: {
                          card: this.values,
                        },
                      });
                    } else {
                      this.$router.push({
                        path: "/home",
                        query: {
                          card: this.values,
                        },
                      });
                    }
                    localStorage.setItem("meCardNum", this.values);
                    localStorage.setItem("card", this.values);
                  }
                }
              } else {
                this.$notify({ type: "warning", message: `${res.msg}` });
              }
            });
          } else {
            this.$notify({ type: "warning", message: `${res.msg}` });
          }
        });
        this.shows = false;
      },
      onSubmit() {
        this.loading = true;
        phoneQuery(this.value)
          .then((res) => {
            this.loading = false;
            console.log(res);
            if (res.status) {
              if (res.data.phoneOrCard == false) {
                this.sort();
              } else {
                this.cardList = res.data.card;
                this.shows = true;
              }
            } else {
              this.$notify({ type: "warning", message: `${res.msg}` });
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      sort() {
        sortCard(this.value).then((res) => {
          if (res.status) {
            this.sspa = res.data;
            if (res.data.virtualNumber) {
              localStorage.setItem("virtualNumber", res.data.virtualNumber);
            }
            this.values = res.data.meCardNum;
            localStorage.setItem("card", this.values);
            localStorage.removeItem("end");
            localStorage.setItem("meCardNum", this.values);
            localStorage.setItem("card", this.values);
            this.$router.push({
                    path: "/certification",
                    query: {
                      card: this.values,
                    },
                  });
            // this.getIndexNotice();
          } else {
            this.$notify({ type: "warning", message: `${res.msg}` });
          }
        });
      },
      getIndexNotice() {
        getByCard(this.value).then((res) => {
          if (res.status) {
            if (this.sspa.coupon == 1) {
              localStorage.setItem("meCardNum", this.values);
              localStorage.setItem("card", this.values);
              this.$router.push({
                name: "Discount",
              });
            } else {
              if (this.sspa.codes == 1) {
                this.nameAlerts = true;
                localStorage.setItem("meCardNum", this.values);
                localStorage.setItem("card", this.values);
              } else {
                localStorage.removeItem("222");
                if (this.mk == 3) {
                  this.$router.push({
                    path: "/recharges",
                    query: {
                      card: this.values,
                    },
                  });
                } else {
                  this.$router.push({
                    path: "/home",
                    query: {
                      card: this.values,
                    },
                  });
                }
                localStorage.setItem("meCardNum", this.values);
                localStorage.setItem("card", this.values);
              }
            }
          } else {
            this.$notify({ type: "warning", message: `${res.msg}` });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .floatball {
    color: white;
    height: 40px;
    width: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    padding: 5px;
    z-index: 990;
    position: fixed;
    bottom: 50px;
    right: 20px;
    border-radius: 50%;
    background-color: rgba(29, 157, 237, 0.8);
  }
  .apo {
    background: url("../assets/微信图片_20211019140434.jpg") no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
    width: 100%;
    height: 100vh;
    // background-size: 100%;
  }

  .aa {
    margin: 30px 20px;
    padding: 10px;
    border-radius: 20px;
    background: white;
    box-sizing: border-box;
  }

  .ss {
    margin-top: 130px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
</style>
